export default {
    FETCHED_COMPANY(state, payload) {
        state.company = payload.company
    },
    SET_PROMISE(state, payload) {
        state.promise = payload;
    }
}